module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/@sentry/gatsby/gatsby-browser.js'),
      options: {"plugins":[],"dsn":"https://918173e4b55d4ffbbf743e737fc3f29f@o52013.ingest.sentry.io/5513011","tracesSampleRate":0.1},
    },{
      plugin: require('../node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"/builds/codica-website/codica-gatsby//src/components/layouts"},
    },{
      plugin: require('../node_modules/gatsby-plugin-breakpoints/gatsby-browser.js'),
      options: {"plugins":[],"queries":{"xs":"(max-width: 320px)","sm":"(max-width: 768px)","md":"(max-width: 991px)","lg":"(max-width: 1279px)","xl":"(max-width: 1799px)","xsUp":"(min-width: 320px)","smUp":"(min-width: 720px)","mdUp":"(min-width: 992px)","lgUp":"(min-width: 1280px)","xlUp":"(min-width: 1800px)"}},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Codica - Custom Software Development Consultancy","short_name":"Codica","start_url":"/","background_color":"#3d4067","theme_color":"#3d4067","display":"standalone","icon":"src/assets/images/icons/manifest-icon-512x512.png","legacy":false,"crossOrigin":"use-credentials","cache_busting_mode":"none","theme_color_in_head":true,"include_favicon":true,"cacheDigest":null},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
